export default "__VITE_ASSET__B9orlY9a__"